import React from "react";

import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CurrencyLiraIcon from "@mui/icons-material/CurrencyLira";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import CurrencyYuanIcon from "@mui/icons-material/CurrencyYuan";
import { SvgIconProps } from "@mui/material/SvgIcon";

export const currencyMapping: Record<
  string,
  { symbol: React.ElementType<SvgIconProps>; name: string }
> = {
  EUR: { symbol: EuroSymbolIcon, name: "Euro" },
  USD: { symbol: AttachMoneyIcon, name: "US Dollar" },
  CHF: { symbol: "CHF", name: "Swiss Franc" } as any,
  GBP: { symbol: CurrencyPoundIcon, name: "British Pound" },
  BGN: { symbol: "Лв", name: "Bulgarian Lev" } as any,
  CZK: { symbol: "Kč", name: "Czech Koruna" } as any,
  DKK: { symbol: "kr", name: "Danish Krone" } as any,
  HUF: { symbol: "Ft", name: "Hungarian Forint" } as any,
  PLN: { symbol: "zł", name: "Polish Zloty" } as any,
  RON: { symbol: "lei", name: "Romanian Leu" } as any,
  SEK: { symbol: "kr", name: "Swedish Krona" } as any,
  NOK: { symbol: "kr", name: "Norwegian Krone" } as any,
  ISK: { symbol: "kr", name: "Icelandic Krona" } as any,

  // Americas & Oceania
  CAD: { symbol: AttachMoneyIcon, name: "Canadian Dollar" },
  NZD: { symbol: AttachMoneyIcon, name: "New Zealand Dollar" },
  AUD: { symbol: AttachMoneyIcon, name: "Australian Dollar" },
  COP: { symbol: AttachMoneyIcon, name: "Colombian Peso" },
  MXN: { symbol: AttachMoneyIcon, name: "Mexican Peso" },
  AWG: { symbol: "ƒ", name: "Aruban Florin" } as any,
  BBD: { symbol: AttachMoneyIcon, name: "Barbadian Dollar" },
  BSD: { symbol: AttachMoneyIcon, name: "Bahamian Dollar" },
  BZD: { symbol: AttachMoneyIcon, name: "Belize Dollar" },
  DOP: { symbol: "RD$", name: "Dominican Peso" } as any,
  GYD: { symbol: AttachMoneyIcon, name: "Guyanese Dollar" },
  HTG: { symbol: "G", name: "Haitian Gourde" } as any,
  JMD: { symbol: AttachMoneyIcon, name: "Jamaican Dollar" },
  KYD: { symbol: AttachMoneyIcon, name: "Cayman Islands Dollar" },
  XCD: { symbol: AttachMoneyIcon, name: "Eastern Caribbean Dollar" },

  // Europe & Near East
  TRY: { symbol: CurrencyLiraIcon, name: "Turkish Lira" },
  MDL: { symbol: "L", name: "Moldovan Leu" } as any,
  RSD: { symbol: "дин", name: "Serbian Dinar" } as any,
  
  // Asia
  CNY: { symbol: CurrencyYuanIcon, name: "Chinese Yuan Renminbi" },
  HKD: { symbol: AttachMoneyIcon, name: "Hong Kong Dollar" },
  JPY: { symbol: CurrencyYenIcon, name: "Japanese Yen" },
  INR: { symbol: CurrencyRupeeIcon, name: "Indian Rupee" },
  RUB: { symbol: CurrencyRubleIcon, name: "Russian Ruble" },
  SGD: { symbol: AttachMoneyIcon, name: "Singapore Dollar" },
  KRW: { symbol: "₩", name: "South Korean Won" } as any,
  PKR: { symbol: CurrencyRupeeIcon, name: "Pakistani Rupee" },

  // Africa & Middle East
  QAR: { symbol: "ر.ق", name: "Qatari Riyal" } as any,
  ZAR: { symbol: "R", name: "South African Rand" } as any,
  AED: { symbol: "د.إ", name: "UAE Dirham" } as any,
  KWD: { symbol: "د.ك", name: "Kuwaiti Dinar" } as any,
  ILS: { symbol: "₪", name: "Israeli New Shekel" } as any,
  SAR: { symbol: "ر.س", name: "Saudi Riyal" } as any,
  EGP: { symbol: "£", name: "Egyptian Pound" } as any,
  MAD: { symbol: "د.م", name: "Moroccan Dirham" } as any,
};
